import styled from 'styled-components';

import MessageText from "./message-text";

export default styled(MessageText)`
  margin: ${({ viewOnly }) => viewOnly ? '26px 0' : '0'};
`;
